import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 lg:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              资源分类
            </h2>
            <p className="text-sm text-foreground-500">
              精选四大资源板块，总有一款适合您
            </p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {displayCategories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${category.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-1.5">
                {category.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                {category.description}
              </p>
              <span className="text-xs text-foreground-400">
                {category.count}个资源
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}